import {Component, Input} from '@angular/core';
import {DocumentAttachment, FileAttachment, FileAttachmentApiService, ReferenceBookResponse} from '@npck/af-frontend-api';
import {downloadFromBlobResponse, rxSpinner, Spinner} from '@npck/libs/commons';
import {findValueInDictionary} from '../../../domain/dictionary-holder.service';
import {AttachmentViewModel} from '../../../pages/incidents/details/documents-tab/documents-tab.component';

@Component({
    selector: 'af-file-preview',
    templateUrl: './file-preview.component.html',
    styleUrl: './file-preview.component.scss',
    standalone: false,
})
export class FilePreviewComponent {
    @Input() file: FileViewModel;
    Spinner = Spinner;

    constructor(private fileAttachmentApiService: FileAttachmentApiService) {
    }

    downloadFile(file: FileAttachment): void {
        this.fileAttachmentApiService.downloadFile(file.id, 'response')
            .pipe(rxSpinner(`downloadFile_${file.id}`))
            .subscribe(response => downloadFromBlobResponse(response));
    }
}

export function mapToViewModel(filesWithDocumentType: DocumentAttachment, docTypes: ReferenceBookResponse[]): AttachmentViewModel {
    return {
        documentType: findValueInDictionary(docTypes, filesWithDocumentType.docType, 'name_ru'),
        files: filesWithDocumentType.files.map(file => <FileViewModel>{
            isHovered: false,
            file: file,
        }),
    };
}

export interface FileViewModel {
    isHovered?: boolean;
    file: FileAttachment;
}
